var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-list"},_vm._l((_vm.posts),function(post){return _c('PostPreview',{key:post.title,attrs:{"title":post.title,"date":post.date,"image":post.image,"body":post.body,"post-name":post.postName}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }